<template>
  <v-container
    id="regular-forms-view"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        v-if="!isNew && !banner"
        cols="12"
      >
        <i class="fas fa-spin fa-spinner"></i>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <material-card
          color="primary"
          :heading="pageTitle"
        >
          <v-card-text>
            <validation-observer v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(submit)">
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      :name="$t('forms.label').toLowerCase()"
                    >
                      <v-text-field
                        v-model="form.label"
                        :error-messages="errors"
                        outlined
                        :label="$t('forms.label')"
                        :hint="$t('banner_label_hint')"
                        persistent-hint
                        class="mb-4"
                      />
                    </validation-provider>
                    <v-text-field
                      v-model="form.link"
                      outlined
                      :label="$t('forms.link')"
                      :hint="$t('banner_link_hint')"
                      persistent-hint
                      class="mb-4"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <DateTimePicker
                          v-model="form.starts_at"
                          :label="$t('forms.starts_at')"
                          with-time
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <DateTimePicker
                          v-model="form.ends_at"
                          :label="$t('forms.ends_at')"
                          with-time
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <p class="text-caption mt-n4">
                      {{ $t('banner_dates_hint') }}
                    </p>
                    <DropzoneComponent
                      v-model="form.desktop_pictures"
                      :label="$t('dropzone.label_singular')"
                      :max-files="1"
                      :field-label="`${$t('forms.banner_desktop')} — ${$t('banner_desktop_hint')}`"
                      no-crop
                      class="mt-2"
                    />
                    <DropzoneComponent
                      v-model="form.mobile_pictures"
                      :label="$t('dropzone.label_singular')"
                      :max-files="1"
                      :field-label="`${$t('forms.banner_mobile')} — ${$t('banner_mobile_hint')}`"
                      no-crop
                      class="mt-6"
                    />
                  </v-col>
                </v-row>
                <div class="full-width d-flex justify-space-between align-center mt-4">
                  <v-btn
                    color="gray"
                    to="/homepage/banners"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    type="submit"
                    :color="processing ? 'gray' : 'success'"
                  >
                    <v-icon
                      class="mr-3"
                      small
                      v-text="processing ? 'fas fa-spinner fa-spin' : 'fas fa-check'"
                    />
                    {{ $t('submit') }}
                  </v-btn>
                </div>
              </v-form>
            </validation-observer>
          </v-card-text>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import serverError from '../../mixins/serverError';
  import DateTimePicker from '../../components/DateTimePicker';
  export default {
    name: 'BannerForm',

    components: { DateTimePicker },

    mixins: [serverError],

    data: () => ({
      form: {
        label: null,
        link: null,
        starts_at: null,
        ends_at: null,
        desktop_pictures: [],
        mobile_pictures: [],
      },
    }),

    computed: {
      ...mapGetters({
        processing: 'global/getProcessing',
        banner: 'banner/getBanner',
      }),
      isNew() {
        return !this.$route.params.id;
      },
      pageTitle() {
        return this.isNew ? this.$t('pageTitles.NewBanner') : this.$t('pageTitles.Editing') + this.banner.label;
      },
    },

    created() {
      if (!this.isNew) {
        this.$store.dispatch('banner/fetchBanner', this.$route.params.id)
          .then(() => {
            this.form = {
              ...this.banner,
              desktop_pictures: this.banner.desktop_picture ? [this.banner.desktop_picture] : [],
              mobile_pictures: this.banner.mobile_picture ? [this.banner.mobile_picture] : [],
            };
          })
          .catch(error => this.displayErrors(error));
      }
    },

    methods: {
      submit () {
        if (!this.processing) {
          const { id, label, link, starts_at, ends_at, desktop_pictures, mobile_pictures } = this.form;
          const pictureId = pictures => (pictures && pictures[0] && pictures[0].id) || null;
          const payload = {
            id,
            label,
            link: link || null,
            starts_at: starts_at || null,
            ends_at: ends_at || null,
            desktop_picture_id: pictureId(desktop_pictures),
            mobile_picture_id: pictureId(mobile_pictures),
          };
          const action = this.isNew ? 'banner/createBanner' : 'banner/updateBanner';
          const message = this.isNew ? this.$t('successfully_created') : this.$t('successfully_updated');
          this.$store.dispatch(action, payload)
            .then(() => {
              this.$toasted.success(message);
              this.$router.push('/homepage/banners');
            })
            .catch(error => this.displayErrors(error));
        }
      },
    },
  }
</script>
